import { axiosInstance } from "../../../@core/auth/jwt/jwtService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const axios = require("axios");
const url = process.env.REACT_APP_URI;

export const getSubscriptions = createAsyncThunk(
  "subs/getSubscriptions",
  async (args, thunkAPI) => {
    const { pageSize, pageNumber, searchQuery, eventId } = args;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/subscriptions?display=true,false`,
        method: "get",
        params: {
          pageSize,
          pageNumber,
          searchQuery,
        },
      });
      return { data: response };
    } catch (error) {
      console.log("error : ", error);
      return thunkAPI.rejectWithValue(
        "Error al consultar los cupones. Error: ",
        error.message
      );
    }
  }
);

export const getSubsToSelect = createAsyncThunk(
  "subs/getSubsToSelect",
  async (eventId, thunkAPI) => {
    const response = await axiosInstance.request({
      url: `/events/${eventId}/subscriptions?fields=name,id,customFields&display=true,false`,
      method: "get",
      params: { pageSize: 100 },
    });
    return response;
  }
);

export const getSubGroupsToSelect = createAsyncThunk(
  "subs/getSubsGroupsToSelect",
  async (eventId, thunkAPI) => {
    const response = await axiosInstance.request({
      url: `/events/${eventId}/subscriptionGroups`,
      method: "get",
      params: { display: "true,false", pageSize: 100 },
    });
    return response;
  }
);

export const createSub = createAsyncThunk(
  "subs/createSub",
  async (data, thunkAPI) => {
    const { eventId, newSubData } = data;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/subscriptions`,
        method: "post",
        data: newSubData,
      });
      return { data: response };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar las suscripciones. Error: ",
        error.message
      );
    }
  }
);

export const subscriptionsSlice = createSlice({
  name: "subs",
  initialState: {
    list: [],
    totalRows: 0,
    newPrices: [],
    groupsList: [],
    newSettings: {},
    loadingStatus: "",
    pending: false,
    newTranslations: [],
    newCustomFields: [],
    newPricesFree: false,
    subscriptionToCreate: null,
  },
  reducers: {
    setSubsList: (state, action) => {
      state.list = action.payload;
    },
    updateNewSubscriptionData: (state, action) => {
      const { settingsData, translationsData } = action.payload;

      state.newSettings = settingsData;
      state.newTranslations = translationsData;
    },
    updateNewSubscriptionCustomFields: (state, action) => {
      const { customFields } = action.payload;

      state.newCustomFields = customFields;
    },
    updateNewSubscriptionPrices: (state, action) => {
      const { prices } = action.payload;

      console.log(prices);
      state.newPrices = prices;
    },
    updateNewSubscriptionFree: (state, action) => {
      state.newPricesFree = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSubscriptions.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.totalRows = JSON.parse(data?.headers["x-pagination"])?.totalCount;
        state.list = data.data;
        state.pending = false;
      })
      .addCase(getSubscriptions.pending, (state) => {
        state.pending = true;
      })
      .addCase(getSubscriptions.rejected, (state) => {
        state.pending = false;
      })
      .addCase(getSubsToSelect.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.list = data;
        state.loadingStatus = "succeeded";
      })
      .addCase(getSubsToSelect.rejected, (state) => {
        state.loadingStatus = "failed";
      })
      .addCase(getSubGroupsToSelect.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.groupsList = data;
        state.loadingStatus = "succeeded";
      })
      .addCase(getSubGroupsToSelect.rejected, (state) => {
        state.loadingStatus = "failed";
      })
      .addCase(createSub.fulfilled, (state, action) => {})
      .addCase(createSub.rejected, (state) => {
        state.loadingStatus = "failed";
      });
  },
});

export const deleteSubscription = async (id, eventId) => {
  await axios.delete(`/events/${eventId}/subscriptions/${id}`);
};

export const {
  setSubsList,
  updateNewSubscriptionData,
  updateNewSubscriptionCustomFields,
  updateNewSubscriptionPrices,
  updateNewSubscriptionFree,
} = subscriptionsSlice.actions;
export default subscriptionsSlice.reducer;
